module.exports = __webpack_public_path__ + "static/media/paris_florist_getty_desktop.e0c07d47.jpg";